import { useState, useEffect, useMemo, useRef, useCallback } from 'react'
import { UrlApi } from '../../../../services/apirest'
import { Grid, InputAdornment, Container, Checkbox, MenuItem, Button } from '@mui/material'
import moment from 'moment';
import Autocomplete from '@mui/material/Autocomplete';
import Box from "@mui/material/Box";
import MaterialReactTable from "material-react-table";
import { Select, FormControl, InputLabel, Stack, FormControlLabel, TextField } from '@mui/material'
import Notify from '../../../Notify'
import { DownloadFiles, ViewUploadFile } from '../../../../services/DownloadFiles';
import { AdjuntoFileCard } from '../../../Form/AdjuntoField';
import { formatoImporte } from '../../formatoImporte';
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import Title from '../../../Title';
import AgregarMateriales from '../../requerimientos/ver_requerimientos/lista_requerimientos/AgregarMateriales';
import { getData, putData } from '../../../../services/library';
import { logEventos } from '../../../../services/services';
import FormAgregarPedido from '../AddOrdenes/AddRequerimientos/FormAgregarPedido';

export default function EditarOrden(props) {
    const [datos, setDatos] = useState(props.datos);
    const [listaMaterial, setlistaMaterial] = useState([]);
    const [proveedores, setProveedores] = useState('');
    const [tipoMoneda, settipoMoneda] = useState(null);
    const [condVenta, setCondVenta] = useState(null);
    const [bonificacionPesos, setBonificacionPesos] = useState(props.datos.bonificacion_pesos);
    const [bonificacionPorcentaje, setBonificacionPorcentaje] = useState(props.datos.bonificacion_porcentaje);
    const [totalFinal, settotalFinal] = useState(props.datos.total);
    const globalTheme = useTheme();
    const [condVentaNew, setCondVentaNew] = useState(null);
    const [openDialog, setopenDialog] = useState(false);
    const [proveedorSelected, setproveedorSelected] = useState("");
    const [presupuestos, setPresupuestos] = useState([]);
    const [cargandoPresupuesto, setCargandoPresupuesto] = useState(false);
    const [errorPresupuesto, setErrorPresupuesto] = useState("");
    const [datosReq, setDatosReq] = useState();
    const [tabla, settabla] = useState(true);
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [sucursales, setSucursales] = useState(null);
    const [vehiculos, setVehiculos] = useState(null);
    const [subtotal, setsubtotal] = useState(0);
    const [empresas, setempresas] = useState(null);
    const [notificacion, setNotificacion] = useState({
        open: false,
        mensaje: "",
        severity: "",
        color: "",
    });

    const obtenerDatosReq = async () => {
        getData('/requerimientos_materiales/actualizada/ordencompra/' + datos.uuid_ordencompra, setDatosReq)
    };

    const obtenerMovil = () => {
        getData('/vehiculos/sucursal/' + datos.id_sucursal, setVehiculos)
    };

    const obtenerListaMaterial = () => {
        getData('/lista_materiales/actualizada/ordencompra/' + datos.uuid_ordencompra, setlistaMaterial)
    };

    useEffect(() => {
        // getData('/proveedores', setProveedores)
        getData('/proveedores/sintesis', setProveedores)
        getData('/desplegables/tipoMoneda', settipoMoneda)
        getData('/condicion_pago', setCondVenta)
        getData('/sucursales', setSucursales)
        getData('/empresas', setempresas)
    }, []);

    useEffect(() => {
        obtenerMovil()
    }, [datos.id_sucursal]);

    useEffect(() => {
        if (proveedores) {
            const proveedor = proveedores.find((p) => p.id === datos.id_proveedor)
            setproveedorSelected(proveedor)
        }
    }, [datos.id_proveedor, proveedores]);

    useEffect(() => {
        if (condVenta) {
            const condicion = condVenta.filter((condicion) => condicion.id === datos.condicion_venta)
            setCondVentaNew(condicion[0])
        }
    }, [datos.condicion_venta, condVenta]);

    useEffect(() => {
        obtenerListaMaterial()
        props.datos && obtenerDatosReq()
    }, [datos.uuid_ordencompra]);

    const getPresupuestos = useCallback(() => {
        fetch(UrlApi + "/uploadfiles/todownload/" + datos.uuid_ordencompra)
            .then((res) => res.json())
            .then((data) => setPresupuestos(Array.isArray(data) ? data : []))
            .catch(() => setPresupuestos([]));
    }, [datos.uuid_ordencompra]);

    useEffect(() => {
        getPresupuestos();
    }, [getPresupuestos]);

    const handlePresupuestoChange = async (e) => {
        const file = e.target.files?.[0];
        e.target.value = "";
        if (!file) return;

        setCargandoPresupuesto(true);
        setErrorPresupuesto("");
        const data = new FormData();
        data.append("uid", datos.uuid_ordencompra);
        data.append("archivo", file);

        try {
            const res = await fetch(UrlApi + "/uploadfiles/uploadfiles", {
                method: "POST",
                body: data,
            });
            const body = await res.json().catch(() => ({}));
            if (!res.ok) {
                throw new Error(body?.message || "No se pudo cargar el archivo");
            }
            getPresupuestos();
        } catch (err) {
            setErrorPresupuesto(err.message || "No se pudo cargar el archivo");
        } finally {
            setCargandoPresupuesto(false);
        }
    };

    const quitarPresupuesto = async (archivo) => {
        if (!window.confirm("Usted está por eliminar el archivo: " + archivo.nombre)) return;

        try {
            const res = await fetch(UrlApi + "/uploadfiles/todownload/" + archivo.id, {
                method: "DELETE",
                headers: { "Content-Type": "application/json" },
            });
            if (!res.ok) {
                setErrorPresupuesto("No se borro el archivo");
                return;
            }
            setErrorPresupuesto("");
            getPresupuestos();
        } catch (err) {
            setErrorPresupuesto("No se borro el archivo");
        }
    };

    useEffect(() => {
        getBonificacionPorcentaje()
    }, [bonificacionPorcentaje, subtotal]);

    const getTotal = () => {
        let subtotal = 0
        if (listaMaterial) {
            listaMaterial.map((item) => subtotal = subtotal + item.subtotal)
            setsubtotal(subtotal)
        }
    };

    const getBonificacionPorcentaje = () => {
        if (!!subtotal && !!bonificacionPorcentaje) {
            settotalFinal(subtotal - (subtotal * bonificacionPorcentaje / 100))
        } else if (!!subtotal && !!bonificacionPesos) {
            settotalFinal(subtotal - bonificacionPesos)
        }
        else {
            settotalFinal(subtotal)
        }
    };

    useEffect(() => {
        getTotal()
    }, [listaMaterial]);

    const almacenar = (e) => {
        setDatos({ ...datos, [e.target.name]: e.target.value ? e.target.value : "" })
    };

    const getColumns = (datos) => {
        let columns = [
            {
                header: 'Requerido',
                accessorKey: 'cantidad',
                accessorFn: (row) => {
                    const esManual = datos.origen === "manual";
                    const cantidad = Number(row.cantidad ?? 0);
                    const cantidadActualizada = Number(row.cantidad_actualizada ?? 0);
                    const totalActualizada = Number(row.total_cantidad_actualizada ?? 0);

                    if (esManual) {
                        // Si no se actualizó o sigue igual → mostrar cantidad original
                        if (!cantidadActualizada || cantidadActualizada === cantidad) {
                            return cantidad;
                        }
                        // Si se cambió → mostrar cantidad_actualizada
                        return cantidadActualizada;
                    }

                    // Si no es manual → mostrar total_cantidad_actualizada
                    return totalActualizada;
                },
                size: 70,
                enableEditing: datos.origen === "manual",
                muiEditTextFieldProps: {
                    type: "number",
                    inputProps: { min: 0 },
                    disabled: datos.origen !== "manual",
                    onChange: (e) => {
                        e.target.value = e.target.value;
                    },
                },
            }
            ,
            { header: 'Articulo', accessorFn: (lm) => lm.nombre ?? lm.material, enableEditing: false, },
            { header: 'Unidad', accessorFn: (lm) => lm.descripcion ?? lm.descripcion_material, enableEditing: false, size: 59 },
            {
                header: '$ Unitario',
                accessorKey: 'precio_unitario',
                size: 40,
                muiEditTextFieldProps: {
                    type: 'text',
                    inputMode: 'decimal',
                    onChange: (e) => {
                        // permitir solo números y coma
                        e.target.value = e.target.value.replace(/[^0-9,]/g, '');
                    },
                    onBlur: (e) => {
                        let value = e.target.value.trim();
                        // console.log("value", value);

                        if (!value) return;

                        // reemplazar solo si NO tiene punto como decimal (para evitar 100.99 → 10099)
                        if (value.includes(',')) {
                            value = value.replace(',', '.');
                        }

                        const num = parseFloat(value);
                        if (!isNaN(num)) {
                            e.target.value = num.toFixed(2).replace('.', ',');
                        }
                    },
                },
                Cell: ({ cell }) => formatoImporte(cell.getValue()),
            },
            { header: 'Bonif %', accessorKey: 'bonificacion_porcentaje', type: 'numeric', required: false, size: 40 },
            {
                header: 'Bonif $',
                accessorKey: 'bonificacion_pesos',
                type: 'numeric',
                required: false,
                size: 40,
                Cell: ({ cell }) => formatoImporte(cell.getValue()),
            },
            {
                header: 'SubTotal',
                accessorKey: 'subtotal',
                type: 'double',
                enableEditing: false,
                size: 50,
                Cell: ({ cell }) => formatoImporte(cell.getValue()),
            },
        ];
        if (datos.origen === "requerimiento") {
            // Insertar la nueva columna en la segunda posición
            columns.splice(1, 0, { header: 'A Comprar', accessorKey: 'cantidad_actualizada', type: 'numeric', size: 70 });
        }

        return columns;
    };

    const columns = useMemo(() => getColumns(datos), [datos])

    const tableTheme = useMemo(
        () =>
            createTheme({
                palette: {
                    mode: globalTheme.palette.mode,
                    primary: globalTheme.palette.primary, //primary color for the table
                    info: {
                        main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
                    },
                    background: {
                        default:
                            globalTheme.palette.mode === "light"
                                ? "rgb(234, 239, 241)"
                                : "#000", //pure black table in dark mode for fun
                    },
                },
                typography: {
                    button: {
                        textTransform: "none", //customize typography styles for all buttons in table by default
                        fontSize: "1rem",
                    },
                },
                components: {
                    MuiTooltip: {
                        styleOverrides: {
                            tooltip: {
                                fontSize: "0.8rem", //larger tooltip font size                                
                            },
                        },
                    },
                },

            }), [globalTheme]);


    const tableHeadCellProps = {
        align: "center",
        sx: {
            fontSize: 16,
            color: "white",
            fontWeight: "normal",
            backgroundColor: "#2471A3",
            borderColor: "black",
        },
    };

    const initialState = {
        density: "compact",
        showGlobalFilter: true,
        pagination: { pageIndex: 0, pageSize: 15 }
    };

    const style = {
        backgroundColor: "#ffffff",
        width: "100%"
    };

    const handleClose = () => {
        props.editar(false)
        props.tabla(true)
        props.tabs(true)
    };

    const handleAbrirModal = () => {
        setopenDialog(true)
    };

    const guardarTodo = async ({ exitEditingMode, row, values }) => {
        //Función para convertir correctamente números con formato AR (1.234,56 → 1234.56)
        const parseValor = (val) => {
            if (val === null || val === undefined || val === '') return 0;

            let limpio = String(val).trim();

            // ✅ Si ya viene como número normal (100.34) → no tocarlo
            if (/^\d+(\.\d+)?$/.test(limpio)) {
                return parseFloat(limpio);
            }

            // Si tiene coma decimal y punto de miles → eliminar los puntos
            if (/,/.test(limpio) && /\./.test(limpio)) {
                limpio = limpio.replace(/\./g, '');
            }

            // Reemplazar coma decimal por punto
            limpio = limpio.replace(',', '.');

            const num = parseFloat(limpio);
            return isNaN(num) ? 0 : num;
        };

        const precio_unitario = parseValor(values.precio_unitario);
        const esManual = datos.origen === "manual";

        // console.log("precio unitar", precio_unitario);


        //  Bonificaciones
        const bonificacion_pesos = values.bonificacion_pesos ? parseValor(values.bonificacion_pesos) : null;
        const bonificacion_porcentaje = values.bonificacion_porcentaje ? parseValor(values.bonificacion_porcentaje) : null;

        //  Determinar la cantidad a usar en el cálculo
        let cantidad_a_multiplicar = 0;

        if (esManual) {
            const cantidad = Number(values.cantidad ?? 0);
            const cantidad_actualizada = Number(values.cantidad_actualizada ?? 0);

            if (cantidad_actualizada === null || cantidad_actualizada === 0) {
                cantidad_a_multiplicar = cantidad; // no se actualizó nada
            } else if (cantidad_actualizada !== cantidad) {
                cantidad_a_multiplicar = cantidad_actualizada; // el usuario la cambió
            } else {
                cantidad_a_multiplicar = cantidad; // sigue igual
            }
        } else {
            // si NO es manual uso el total proveniente de requerimientos
            cantidad_a_multiplicar = Number(row.original.total_cantidad_actualizada ?? 0);
        }

        // console.log("Cantidad a multiplicar:", cantidad_a_multiplicar);
        // console.log("Precio unitario parseado:", precio_unitario);

        //  Calcular subtotal
        let subtotal = 0;

        if (bonificacion_pesos) {
            subtotal = (cantidad_a_multiplicar * precio_unitario) - bonificacion_pesos;
        } else if (bonificacion_porcentaje) {
            subtotal = (precio_unitario * cantidad_a_multiplicar) * (1 - bonificacion_porcentaje / 100);
        } else {
            subtotal = precio_unitario * cantidad_a_multiplicar;
        }

        //  Construir body
        const body = {
            precio_unitario,
            subtotal,
            bonificacion_pesos,
            bonificacion_porcentaje,
            uuid_ordencompra: datos.uuid_ordencompra,
            usuario: localStorage.getItem('user'),
        };

        if (esManual) {
            body.cantidad_actualizada = cantidad_a_multiplicar;
        }

        //  Guardar en el backend
        await fetch(`${UrlApi}/lista_materiales/lista/${row.original.idlista}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
        });

        obtenerListaMaterial();
        exitEditingMode();

        logEventos(
            "Editar lista materiales de orden compra",
            "Generar ordenes",
            "Ordenes compra",
            localStorage.getItem("user")
        );
    };

    const guardarOrdenCompra = async (e) => {
        putData(e,
            "/ordencompra/postproveedores/" + datos.idordencompra,
            {
                orden: {
                    id_proveedor: proveedorSelected.id,
                    comentarios_internos: datos.comentarios_internos,
                    pago_anticipado: datos.pago_anticipado,
                    iva_incluido: datos.iva_incluido,
                    condicion_venta: condVentaNew.id,
                    tipo_moneda: datos.tipo_moneda,
                    usuario: localStorage.getItem('user'),
                    fecha_entrega: datos.fecha_entrega,
                    id_estado: 89,
                    bonificacion_pesos: parseFloat(bonificacionPesos),
                    bonificacion_porcentaje: parseFloat(bonificacionPorcentaje),
                    id_vehiculo: datos.id_vehiculo,
                    id_sucursal: datos.id_sucursal,
                    total: totalFinal,
                    facturar_a_empresa: datos.facturar_a_empresa
                },
                ...proveedorSelected?.padron ? {
                    nuevoProveedor: {
                        inactivo: 0,
                        nro_cuit: proveedorSelected.cuit.trim(),
                        razon_social: proveedorSelected.denominacion.trim(),
                        id_condicionventa: condVentaNew.id,
                        usuario: localStorage.getItem("user"),
                        observaciones: "Proveedor cargado por EDICION en carga de ORDEN DE COMPRA."
                    }
                } : {}
            },
            setNotificacion,
            logEventos("Editar orden de compra", "Generar ordenes", "Ordenes compra", localStorage.getItem("user"))
        )

    };

    const handleCreateNewRow = (values) => {
        setCreateModalOpen(true);
    };

    const timeoutRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const getProveedores = async (busqueda) => {
        if (!busqueda) return;

        setLoading(true);

        try {
            const res = await fetch(
                UrlApi + `/proveedores_padron/search?query=${encodeURIComponent(busqueda)}`
            );
            const data = await res.json();
            setProveedores(data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    // console.log("proveedor selected:", proveedorSelected)

    return (
        // <>
        // </>
        <div>
            <Container maxWidth="xl">
                <Title
                    titulo={`Editar orden de compra N° ${datos.idordencompra}`}
                    handleClose={handleClose} />

                <Box backgroundColor="#F4F6F6"
                    mt={1}
                    p={3}
                    mb={2}
                    border={0.5}
                    borderColor={"#ABB2B9"}
                    borderRadius={4}>
                    <Grid container spacing={2} alignItems='center' >
                        <Grid item xs={3} alignItems='flex-start'>
                            <Autocomplete
                                required
                                sx={{ backgroundColor: "#fff" }}
                                disableClearable
                                placeholder="Nombre, CUIT o Sisven ID"
                                options={proveedores || [{}]}
                                value={proveedorSelected}
                                loading={loading}
                                loadingText={"Cargando..."}
                                onChange={(event, value) => {
                                    setproveedorSelected(value);
                                }}
                                noOptionsText={"No existe proveedor"}
                                onInputChange={(e, value, reason) => {
                                    if (timeoutRef.current) {
                                        clearTimeout(timeoutRef.current);
                                        timeoutRef.current = null;
                                    }

                                    if (reason === "input") {

                                        if (value?.length >= 2) {
                                            timeoutRef.current = setTimeout(() => {
                                                getProveedores(value);
                                                timeoutRef.current = null;
                                            }, 300);
                                        } else {
                                            setProveedores([]);
                                        }
                                    }
                                }}
                                getOptionLabel={(option) =>
                                    `${option?.denominacion?.trim()} (${option?.cuit})`
                                }
                                renderOption={(props, option) => (
                                    <Box
                                        component="li"
                                        key={option.denominacion}
                                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                                        {...props}
                                    >
                                        {`${option?.denominacion?.trim()} (${option?.cuit}) `}
                                    </Box>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        focused
                                        fullWidth
                                        placeholder="Tipee para buscar proveedores.."
                                        {...params}
                                        variant="outlined"
                                        size="small"
                                        label="Proveedor"
                                        required={proveedorSelected === null}
                                    />
                                )}
                                isOptionEqualToValue={(option, value) => option.valueOf === value || value === ""}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControl style={style} size="small" focused color="primary" required >
                                <InputLabel id="lbl_estado">Condicion De Venta</InputLabel>
                                <Select
                                    variant='outlined'
                                    name='condicion_venta'
                                    value={condVentaNew || ""}
                                    onChange={(e) => {
                                        setCondVentaNew(e.target.value)
                                        setDatos({ ...datos, condicion_venta: e.target.value.id })
                                    }}
                                    label="Condición de venta">
                                    {(condVenta ?? []).map(elemento => (
                                        <MenuItem key={elemento.id} value={elemento}>
                                            {elemento.condicion}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={2}>
                            <FormControl fullWidth={true} style={style} focused color="primary" required size="small">
                                <InputLabel id="lbl_estado">Moneda</InputLabel>
                                <Select
                                    required
                                    variant='outlined'
                                    name='tipo_moneda'
                                    value={datos.tipo_moneda || ""}
                                    onChange={almacenar}
                                    label="Moneda">
                                    {(tipoMoneda ?? []).map(elemento => (
                                        <MenuItem key={elemento.id} value={elemento.id}>
                                            {elemento.valor}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={2}>
                            <FormControl fullWidth={true} style={style} focused color="primary" required size="small">
                                <InputLabel id="lbl_estado">Facturar a </InputLabel>
                                <Select
                                    required
                                    variant='outlined'
                                    name='facturar_a_empresa'
                                    value={datos.facturar_a_empresa}
                                    onChange={almacenar}
                                    label="Facturar a ">
                                    {(empresas ?? []).map(elemento => (
                                        <MenuItem key={elemento.idempresa} value={elemento.idempresa}>
                                            {elemento.empresa}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={1}>
                            <FormControlLabel
                                checked={datos.iva_incluido === 1}
                                onChange={(e) => setDatos({ ...datos, "iva_incluido": e.target.checked ? 1 : 0 })}
                                control={<Checkbox />}
                                label="Impuestos incluidos"
                                sx={{ "& .MuiSvgIcon-root": { fontSize: 30 } }}
                            />
                        </Grid>

                        <Grid item xs={1} ml={3}>
                            <FormControlLabel
                                checked={datos.pago_anticipado === 1}
                                onChange={(e) => setDatos({ ...datos, "pago_anticipado": e.target.checked ? 1 : 0 })}
                                control={<Checkbox />}
                                label="Pago anticipado"
                                sx={{ "& .MuiSvgIcon-root": { fontSize: 30 } }}
                            />
                        </Grid>
                    </Grid>

                    {datosReq && datosReq?.length > 0 ?
                        <Grid container spacing={2} alignItems='center' mt={0.5} mb={1.5}>

                            <Grid item xs={3}>
                                <TextField
                                    focused
                                    variant='outlined'
                                    fullWidth={true}
                                    color='primary'
                                    style={style}
                                    label='Movil'
                                    size="small"
                                    value={datosReq[0].patente || "No hay registro"}
                                    InputProps={{
                                        readOnly: true
                                    }} />
                            </Grid>

                            <Grid item xs={3}>
                                <TextField
                                    focused
                                    variant='outlined'
                                    style={style}
                                    color='primary'
                                    label='Solicitante'
                                    size="small"
                                    value={datosReq[0].usuario_registra || ""}
                                    InputProps={{
                                        readOnly: true
                                    }} />
                            </Grid>

                            <Grid item xs={3}>
                                <TextField
                                    focused
                                    variant='outlined'
                                    style={style}
                                    label='Autorizante'
                                    size="small"
                                    value={datosReq[0].usuario_autoriza}
                                    placeholder="No hay registro"
                                    InputProps={{
                                        readOnly: true
                                    }} />
                            </Grid>

                            <Grid item xs={3}>
                                <TextField
                                    focused
                                    variant='outlined'
                                    style={style}
                                    label='Sucursal'
                                    size="small"
                                    value={datosReq[0].nombre_sucursal}
                                    placeholder="No hay registro"
                                    InputProps={{
                                        readOnly: true
                                    }} />
                            </Grid>

                            <Grid item xs={6}>
                                <TextField
                                    focused
                                    color='primary'
                                    style={style}
                                    label='Fecha autorizado'
                                    variant='outlined'
                                    size="small"
                                    value={moment(datosReq.fecha_autorizado).format('DD/MM/YYYY')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                />
                            </Grid>

                            <Grid item xs={6} >
                                <TextField
                                    focused
                                    variant='outlined'
                                    style={style}
                                    color='primary'
                                    onChange={almacenar}
                                    size="small"
                                    label='Fecha de entrega'
                                    type='date'
                                    name='fecha_entrega'
                                    value={moment(datos.fecha_entrega).format('YYYY-MM-DD')}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment
                                                position="start"
                                            ></InputAdornment>)
                                    }} />
                            </Grid>

                        </Grid>
                        :
                        <Grid container spacing={2} alignItems='center' mt={0.5} mb={1.5}>
                            <Grid item xs={4}>
                                <TextField
                                    name='id_sucursal'
                                    select
                                    size='small'
                                    style={style}
                                    required
                                    focused
                                    color="primary"
                                    placeholder='Elija una sucursal'
                                    value={datos.id_sucursal || ""}
                                    onChange={almacenar}
                                    label="Sucursal"
                                >
                                    {(sucursales ?? []).map(elemento => (
                                        <MenuItem key={elemento.id} value={elemento.id}>
                                            {elemento.nombre}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={4}>
                                <FormControl style={style} focused color="primary" size='small'>
                                    <InputLabel id="lbl_movil">Movil</InputLabel>
                                    <Select
                                        name='id_vehiculo'
                                        value={datos.id_vehiculo || ""}
                                        onChange={almacenar}
                                        label="Movil">
                                        {(vehiculos ?? []).map(elemento => (
                                            <MenuItem key={elemento.id} value={elemento.id}>
                                                {elemento.modelo}  -  {elemento.patente}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={4} >
                                <TextField
                                    focused
                                    variant='outlined'
                                    style={style}
                                    color='primary'
                                    onChange={almacenar}
                                    size="small"
                                    label='Fecha de entrega'
                                    type='date'
                                    name='fecha_entrega'
                                    value={moment(datos.fecha_entrega).format('YYYY-MM-DD')}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment
                                                position="start"
                                            ></InputAdornment>)
                                    }} />
                            </Grid>
                        </Grid>
                    }

                    {tabla && listaMaterial ? (
                        <Box mt={2} boxShadow={3}>
                            <ThemeProvider theme={tableTheme}>
                                <MaterialReactTable
                                    enableColumnResizing
                                    columns={columns}
                                    data={listaMaterial}
                                    initialState={initialState}
                                    positionActionsColumn='last'
                                    enableExpandAll={false}
                                    enableToolbarInternalActions={true}
                                    muiTableHeadCellProps={tableHeadCellProps}
                                    muiTableBodyCellProps={{
                                        align: "left",
                                        sx: {
                                            backgroundColor: "#fff",
                                            color: "black",
                                            borderColor: "black"
                                        }
                                    }}
                                    enableColumnActions={false}
                                    enableDensityToggle={false}
                                    layoutMode="grid"
                                    localization={MRT_Localization_ES}
                                    enableColumnDragging={false}
                                    enableColumnFilters={false}
                                    enableHiding={false}
                                    editingMode="row"
                                    enableFullScreenToggle={false}
                                    enableBottomToolbar={false}
                                    enableEditing
                                    enableTopToolbar={false}
                                    positionExpandColumn='first'
                                    onEditingRowSave={guardarTodo}
                                />
                            </ThemeProvider>
                        </Box>
                    ) : null}

                    <Grid container alignItems="center" columnGap={2} rowGap={1} m={1}>
                        <Stack direction="row" spacing={2} alignItems="center" py={1} sx={{ flexShrink: 0 }}>
                            <Button
                                onClick={handleAbrirModal}
                                style={{ backgroundColor: '#363979', color: 'white' }}
                                variant="contained"
                            >
                                Agregar Pedidos
                            </Button>
                            <Button size="small" onClick={handleCreateNewRow} color="primary" variant="contained">
                                Agregar articulos
                            </Button>
                            <Box sx={{ width: 400, maxWidth: "100%", flexShrink: 0 }}>
                                {presupuestos.length > 0 ? (
                                    <Stack spacing={1}>
                                        {presupuestos.map((archivo) => (
                                            <AdjuntoFileCard
                                                key={archivo.id}
                                                title="Presupuesto"
                                                idTipoAdjunto={archivo.id}
                                                hasFile
                                                fileName={archivo.nombre}
                                                showViewAction
                                                showDownloadAction
                                                onFileChange={() => {}}
                                                onRemove={() => quitarPresupuesto(archivo)}
                                                onView={() =>
                                                    ViewUploadFile(
                                                        `${archivo.id_archivo}-${archivo.nombre}`,
                                                        archivo.extension
                                                    )
                                                }
                                                onDownload={() =>
                                                    DownloadFiles(`${archivo.id_archivo}-${archivo.nombre}`)
                                                }
                                            />
                                        ))}
                                    </Stack>
                                ) : (
                                    <AdjuntoFileCard
                                        title="Añadir presupuesto"
                                        idTipoAdjunto={0}
                                        hasFile={false}
                                        loading={cargandoPresupuesto}
                                        accept="*/*"
                                        error={Boolean(errorPresupuesto)}
                                        showRemoveAction={false}
                                        showDownloadAction={false}
                                        showViewAction={false}
                                        onFileChange={handlePresupuestoChange}
                                    />
                                )}
                            </Box>
                        </Stack>

                        <Box sx={{ display: "flex", alignItems: "center", gap: 2, ml: { sm: "auto" }, flexWrap: "wrap" }}>
                            <TextField
                                disabled={!!bonificacionPorcentaje}
                                focused
                                variant='outlined'
                                color='primary'
                                label='Bonificación $'
                                size="small"
                                name='bonificacion'
                                sx={{ width: 140, backgroundColor: "#ffffff" }}
                                value={bonificacionPesos}
                                onChange={(e) => setBonificacionPesos(e.target.value)}
                            />
                            <TextField
                                disabled={!!bonificacionPesos}
                                focused
                                variant='outlined'
                                color='primary'
                                label='Bonificación %'
                                size="small"
                                name='bonificacion'
                                sx={{ width: 140, backgroundColor: "#ffffff" }}
                                value={bonificacionPorcentaje}
                                onChange={(e) => setBonificacionPorcentaje(e.target.value)}
                            />
                            <TextField
                                focused
                                sx={{ width: 120, backgroundColor: "#ffffff" }}
                                variant='outlined'
                                color='primary'
                                label='Total'
                                name='total'
                                size="small"
                                value={formatoImporte(totalFinal)}
                                InputProps={{
                                    readOnly: true
                                }}
                            />
                        </Box>
                    </Grid>


                    <Grid container spacing={2} alignItems="center" p={1}>
                        {
                            datosReq && datosReq[0]?.comentarios_internos && (

                                <Grid item xs={6}>
                                    <TextField
                                        focused variant='outlined' style={style} color='primary' size="small" label='Observaciones del requerimiento'
                                        value={datosReq[0]?.comentarios_internos}
                                        InputProps={{
                                            readOnly: true
                                        }}
                                    />
                                </Grid>
                            )
                        }
                        <Grid item xs={6}>
                            <TextField
                                focused variant='outlined' style={style} color='primary' size="small" label='Observaciones que se imprimen en la OC' name='observaciones'
                                value={datos.observaciones}
                                onChange={almacenar}
                            />
                        </Grid>
                    </Grid>

                    <form onSubmit={guardarOrdenCompra}>
                        <Box sx={{ '& > :not(style)': { m: 1, mt: 1 }, }} autoComplete="off" >
                            <TextField
                                placeholder="Comentarios internos"
                                variant='outlined'
                                focused
                                style={style}
                                size="small"
                                name="comentarios_internos"
                                id="id"
                                multiline
                                label="Comentarios internos COMPRAS"
                                color="primary"
                                onChange={almacenar}
                                value={datos.comentarios_internos}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </Box>
                        <Grid mt={1} container direction="row" justifyContent="space-between" alignItemns="center">
                            <Button variant="contained" style={{ backgroundColor: "#ff3333", color: "#ffffff", marginRight: "5%" }} onClick={handleClose} >Volver</Button>
                            <Button variant="contained" type="submit" style={{ backgroundColor: "#2e7d32", color: "#ffffff" }}
                                onSubmit={guardarOrdenCompra}
                            >Guardar Orden</Button>
                        </Grid>
                    </form>
                </Box>
            </Container>
            {openDialog &&
                <FormAgregarPedido
                    open={setopenDialog}
                    reqmaterial={datosReq}
                    uuid={datos.uuid_ordencompra}
                    actualizar={obtenerListaMaterial}
                />
            }
            {createModalOpen ? <AgregarMateriales position={1} open={setCreateModalOpen} actualizar={obtenerListaMaterial} uuidordencompra={datos.uuid_ordencompra}
            /> : null}
            {notificacion && notificacion.open ? (
                <Notify
                    mensaje={notificacion.mensaje}
                    open={notificacion.open}
                    color={notificacion.color}
                    handleClose={handleClose}
                    severity={notificacion.severity}
                />
            ) : null}
            <br />
        </div >
    )
}

//========================================================================
/*----- Component --------------------------------------------------------/
// Developer     : Candela Grosso   
// Creation Date : 30/11/2023
// Version       : 1.0  
// Description   :  Con este componente el usuario es capaz de :
    - EDITAR UNA ORDEN DE COMPRA
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description: 
//========================================================================*/